export function buildPostConfig (options) {
  const opts = options || {}
  const config = {
    params: opts.params || {},
    cancelToken: opts.cancelToken || null,
    responseType: opts.responseType || '',
    headers: {}
  }

  if (opts.contentType) {
    config.headers['content-type'] = opts.contentType
  }

  if (typeof opts.onUploadProgress === 'function') {
    config.onUploadProgress = opts.onUploadProgress
  }

  if (Number.isFinite(opts.timeout) && opts.timeout > 0) {
    config.timeout = opts.timeout
  }

  return config
}
